/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import * as b64$ from "../lib/base64.js";
import { ClosedEnum } from "../types/enums.js";

/**
 * 输出图像的目标格式。支持的值：`png`, `jpeg`, `jpg`, `gif`, `tiff`, `bmp`。
 */
export const PostImageSvgFormat = {
  Png: "png",
  Jpeg: "jpeg",
  Jpg: "jpg",
  Gif: "gif",
  Tiff: "tiff",
  Bmp: "bmp",
} as const;
/**
 * 输出图像的目标格式。支持的值：`png`, `jpeg`, `jpg`, `gif`, `tiff`, `bmp`。
 */
export type PostImageSvgFormat = ClosedEnum<typeof PostImageSvgFormat>;

export const PostImageSvgFormat$zodSchema = z.enum([
  "png",
  "jpeg",
  "jpg",
  "gif",
  "tiff",
  "bmp",
]).describe(
  "输出图像的目标格式。支持的值：`png`, `jpeg`, `jpg`, `gif`, `tiff`, `bmp`。",
);

export type PostImageSvgFile = {
  fileName: string;
  content: Uint8Array | string;
};

export const PostImageSvgFile$zodSchema: z.ZodType<PostImageSvgFile> = z.object(
  {
    content: z.string().describe("Base64-encoded binary content").transform(
      b64$.bytesFromBase64,
    ),
    fileName: z.string(),
  },
);

/**
 * 要转换的 SVG 文件。
 */
export type PostImageSvgRequestBody = {
  file?: PostImageSvgFile | Blob | undefined;
};

export const PostImageSvgRequestBody$zodSchema: z.ZodType<
  PostImageSvgRequestBody
> = z.object({
  file: z.lazy(() => PostImageSvgFile$zodSchema).optional(),
}).describe("要转换的 SVG 文件。");

export type PostImageSvgRequest = {
  format?: PostImageSvgFormat | undefined;
  width?: number | undefined;
  height?: number | undefined;
  quality?: number | undefined;
  body?: PostImageSvgRequestBody | undefined;
};

export const PostImageSvgRequest$zodSchema: z.ZodType<PostImageSvgRequest> = z
  .object({
    body: z.lazy(() => PostImageSvgRequestBody$zodSchema).optional(),
    format: PostImageSvgFormat$zodSchema.default("png"),
    height: z.int().describe(
      "输出图像的高度（像素）。如果省略，将根据 `width` 保持宽高比，或者使用 SVG 的原始高度。",
    ).optional(),
    quality: z.int().default(90).describe(
      "JPEG 图像的压缩质量（1-100）。仅当 `format` 为 `jpeg` 或 `jpg` 时有效。",
    ),
    width: z.int().describe(
      "输出图像的宽度（像素）。如果省略，将根据 `height` 保持宽高比，或者使用 SVG 的原始宽度。",
    ).optional(),
  });

/**
 * 服务器内部错误。SVG 渲染或文件处理过程中发生错误。
 */
export type PostImageSvgInternalServerErrorResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
};

export const PostImageSvgInternalServerErrorResponseBody$zodSchema: z.ZodType<
  PostImageSvgInternalServerErrorResponseBody
> = z.object({
  code: z.string().optional(),
  message: z.string().optional(),
}).describe("服务器内部错误。SVG 渲染或文件处理过程中发生错误。");

/**
 * 请求无效。可能是未上传文件或指定了不支持的输出格式。
 */
export type PostImageSvgBadRequestResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
};

export const PostImageSvgBadRequestResponseBody$zodSchema: z.ZodType<
  PostImageSvgBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  message: z.string().optional(),
}).describe("请求无效。可能是未上传文件或指定了不支持的输出格式。");

export type PostImageSvgResponse =
  | Uint8Array
  | string
  | PostImageSvgBadRequestResponseBody
  | PostImageSvgInternalServerErrorResponseBody;

export const PostImageSvgResponse$zodSchema: z.ZodType<PostImageSvgResponse> = z
  .union([
    z.string().describe("Base64-encoded binary content").transform(
      b64$.bytesFromBase64,
    ),
    z.lazy(() => PostImageSvgBadRequestResponseBody$zodSchema),
    z.lazy(() => PostImageSvgInternalServerErrorResponseBody$zodSchema),
  ]);
